var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"description":_vm.description,"image":_vm.image,"image-size":_vm.imageSize}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }